import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

/**
 * DialogService can be used to open a modal dialog containing the given component
 * import { CentricDialogModule } from '@windmill/ng-windmill/dialog';
 */
class DialogService extends MatDialog {
    /**
     * Method to open an error dialog type
     */
    alert(component, options) {
        options.panelClass = [...this.getPanelClasses(options), 'dialog-error'];
        return this.open(component, options);
    }
    /**
     *  Method to open a warning dialog type
     */
    warning(component, options) {
        options.panelClass = [...this.getPanelClasses(options), 'dialog-warning'];
        return this.open(component, options);
    }
    /**
     * Method to open a message dialog type
     */
    message(component, options) {
        return this.open(component, options);
    }
    /**
     *  Method to open a theme dialog type
     */
    prompt(component, options) {
        return this.open(component, options);
    }
    /**
     *  Method to open a dialog
     */
    open(component, options) {
        this.setMaxWidthAndHeight(options);
        return super.open(component, options);
    }
    setMaxWidthAndHeight(options = {}) {
        if (!options.maxWidth) {
            options.maxWidth = 'auto';
            options.panelClass = [...this.getPanelClasses(options), 'responsive-max-width'];
        }
        if (!options.maxHeight) {
            options.panelClass = [...this.getPanelClasses(options), 'responsive-max-height'];
        }
    }
    getPanelClasses(options = {}) {
        if (!options.panelClass) {
            return [];
        }
        return typeof options.panelClass === 'string' ? [String(options.panelClass)] : options.panelClass;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DialogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DialogService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CentricDialogModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CentricDialogModule, imports: [CommonModule, MatDialogModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricDialogModule, providers: [DialogService], imports: [CommonModule, MatDialogModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, MatDialogModule],
                    providers: [DialogService],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CentricDialogModule, DialogService };
